<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Event" childName="Dashboard"></side-menu>

    <div class="content">
      <dashboard v-if="event" :event="event"></dashboard>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Dashboard from "@/components/Dashboard.vue";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    dashboard: Dashboard,
  },
  data() {
    return {
      event: null,
    };
  },
  created() {
    this.$bind("event", db.collection("event").doc(this.$route.params.id));
  },
  methods: {},
};
</script>

<style lang="scss">
.event-management .btn_nav .contain {
  max-width: 100%;
}

.content {
  padding: 60px;
  margin-left: 250px;
  @media screen and (max-width: 700px) {
    margin-left: unset !important;
    overflow: hidden;
    overflow-x: scroll;
    overflow-y: scroll;
    // position: absolute;
    z-index: -1;
  }
}
</style>
